import { useEffect } from "react";

import { useSelectedLocation } from "components";
import { useTypedQuery } from "hooks";
import { KeyLockersQueryKeys } from "modules/KeyLockersDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

export const useKeyLockersQuery = () => {
  const { selectedLocation } = useSelectedLocation();

  const query = useTypedQuery({
    queryKey: KeyLockersQueryKeys.keyLockers,
    queryFn: async ({ baseUrl, endpoint }) => (await ApiInstance.post(endpoint, { location_id: selectedLocation?.id }, baseUrl)).data.keylockers,
    enabled: Boolean(selectedLocation)
  });

  useEffect(() => {
    if (selectedLocation?.id) query.refetch();
  }, [selectedLocation]);

  return query;
};
